<style lang='scss' scoped>
.nav-shortcut {
	outline: none !important;
	.nav-header {
		font-size: 16px;
		padding: 10px;
		font-weight: 700;
	}
	position: fixed;
	top: 50px;
	left: 290px;
	width: 60%;
	max-height: calc(100% - 50px);
	z-index: 100;
	background-color: #262626;
	padding: 10px 10px 10px 30px;
	color: #fff;
	overflow: auto;
	.nav-project {
		column-width: 200px;
		& > div {
			padding: 12px;
			width: min-content;
			height: 100%;
			overflow: auto;
		}
	}
	.nav-search {
		width: 60%;
		margin: 12px 0;
	}
	.nav-close {
		position: absolute;
		right: 30px;
		top: 30px;
	}

	.nav-item {
		display: block;
		padding: 0px 8px 6px 10px;
		color: #a6a6a6;
		cursor: pointer;
		&:hover {
			color: #4093ff;
		}
	}
}
</style>

<style lang="scss">
.nav-shortcut .nav-search {
	input {
		background: transparent;
		color: #fff;
	}
}
</style>


<template>
	<aside class="nav-shortcut clearfix">
		<vIcon class="nav-close" type="close" size="30" @click.native="close"></vIcon>
		<vInput
			class="nav-search"
			:placeholder="$t('global.nav.shorttip')"
			transfer
			filterable
			@on-attach="handleRouteInput"
		>
			<template v-for="(items) in moduleList" >
				<template v-for="(item) of getModuleMap[items.id]">
                    <div v-for="json of getThreeMeList(item.linklistId)" >
                        <!-- <Tooltip :content="json.isVue ? json.props.to : json.props.href"> -->
                            <vOption
                            :value="json.id"
                            :key="json.id"
                            :attach="json"
                            >{{$t(json.langKey,{defaultValue:json.title})}}</vOption>
                        <!-- </Tooltip> -->
                        
                    </div>
				</template>
			</template>
		</vInput>
		<div class="nav-project">
			<template v-for="(items,index) in moduleList">
				<div v-if="getModuleMap[items.id]" :key="index">
					<header class="nav-header">{{$t(items.langKey,{defaultValue:items.title})}}</header>
                    <div v-for="(item,key) of getModuleMap[items.id]" :key="key" >
                        <div class="font-bold" style="margin-left:10px;margin-bottom:4px">{{$t(item.langKey,{defaultValue:item.title})}}</div>
                        <div v-for="(json,index) of getThreeMeList(item.linklistId)" :key="index" >
                            <router-link
                                v-if="json.isVue"
                                :key="key"
                                class="nav-item"
                                :to="getLink(json)"
                                @click.native.stop="handleRoute(json)"
                            >{{$t(json.langKey,{defaultValue:json.title})}}</router-link>
                            <a
                                v-else
                                :key="key"
                                class="nav-item"
                                :href="getLink(json)"
                                @click.stop="handleRoute(json)"
                            >{{$t(json.langKey,{defaultValue:json.title})}}</a>
                        </div>
                    </div>
				</div>
			</template>
		</div>
	</aside>
</template>

<script>
import { mapState, mapGetters,mapMutations } from 'vuex';
export default {
	data() {
		return {
			checked: [],
		};
	},
	created() {
		this.checked = this.navTitle;
	},
	mounted() {
		document.addEventListener('click', this.handleClickOut, false)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleClickOut)
	},
	computed: {
		...mapState('layout', ['moduleList']),
        ...mapGetters('layout', ['getModuleMap', 'getMenuList']),
	},
	methods: {
		...mapMutations('layout', ['setRouteId']),
		/**
		 * 获取链接
		 * @param item
		 */
		getLink(item) {
			return this.$parent.getLink(item);
		},
         getThreeMeList (moduid) {
             if (!moduid) return;
            let menuList = this.getMenuList
            let arr = [];
            // console.log('moduid', moduid);
            // console.log('menuList', menuList);
            Object.keys(menuList).forEach(function (key) {
                // console.log(key)
                moduid.forEach(function (id) {
                if (menuList[key].id === id) {
                    arr.push(menuList[key])
                }
                })
            });
            arr = arr.sort(this.compareAttribute('sortIndex'))
            return arr;
        },
		//搜索跳转链接
		handleRouteInput(data) {
			data = this.$parent.getRouteData(data);
			if (data.isVue) {
				this.$nextTick(() => {
					this.setRouteId(data.id);
					this.$router.push(data.props.to)
				})
			} else {
				window.open(data.props.href, '_blank')
			}
			this.close();
		},
		handleRoute(data) {
			this.$parent.handleRoute(data);
			this.close();
		},
		close() {
			this.$parent.modvisible = false;
		},
		handleClickOut(e) {
			const target = e.target;
			if (this.$el.contains(target) || document.querySelector('#nav-module-title').contains(target)) return
			this.close();
		},

	},
};
</script>
